import { useWOpsAdminAccess } from './useWOpsAdminAccess';

export function useDefaultDashboard() {
  const { canAccessWOpsAdminExtras, loading } = useWOpsAdminAccess();

  const dashboardPath = canAccessWOpsAdminExtras
    ? '/tracker/admin/w-ops/overview'
    : '/tracker/log';

  return { dashboardPath, loading };
}
